<template>
  <div
    class="modal fade"
    tabindex="-1"
    role="dialog"
    aria-labelledby="basicModal"
    aria-hidden="true"
  >
    <div
      class="modal-dialog modal-lg modal-dialog-centered"
      role="document"
    >
      <div class="modal-content p-5">
        <div class="col-12 mx-auto">
          <h3 class="title text-center mb-3">
            Cadastre-se na nossa newsletter
          </h3>
          <label for="frmNome">Seu nome</label>
          <input
            id="frmNome"
            v-model="frmNome"
            class="no-round-input"
          >
          <label
            class="mt-2"
            for="frmEmail"
          >Seu email</label>
          <input
            id="frmEmail"
            v-model="frmEmail"
            class="no-round-input"
          >
          <label
            class="mt-2"
            for="frmDtNascimento"
          >Data de nascimento</label>
          <input
            id="frmDtNascimento"
            v-model="frmDtNascimento"
            class="no-round-input"
            type="date"
          >
          <div class="account-method">
            <div class="account-save mt-2">
              <input
                id="savepass"
                v-model="frmTermo"
                class="cursor-pointer"
                type="checkbox"
              >
              <label>Eu aceito os <strong><a
                class="cursor-pointer"
                v-on:click="showTermo"
              >termos de uso</a></strong></label>
            </div>
          </div>
          <div class="account-function">
            <button
              id="frmNewsButton"
              class="no-round-btn"
              v-on:click="enviaNewsletter"
            >
              Participar
              <span
                id="loading"
                class="spinner-border spinner-border-sm d-none"
              ></span>
            </button>
            <div
              class="col-9 d-inline-block text-center"
              v-text="resultMessage"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    data () {
        return {
            frmNome: '',
            frmEmail: '',
            frmDtNascimento: '',
            frmTermo: false,
            resultMessage: '',
            loading: false
        };
    },
    methods: {
        show () {
            $(this.$el).modal();
        },
        enviaNewsletter () {
            if (this.frmNome !== '' && this.frmEmail !== '' && this.frmTermo && !this.loading
                && moment().diff(this.frmDtNascimento, 'years') >= 18) {
                this.loading = true;
                let details = {
                    nome: this.frmNome,
                    email: this.frmEmail,
                    dtNascimento: this.frmDtNascimento,
                };

                window.toggleSaveLoading(false, 'Enviado', 'frmNewsButton');
                this.$http.post('/newsletter', details).then((response) => {
                    if (response.body.success) {
                        window.toggleSaveLoading(true, 'Enviado', 'frmNewsButton');
                        this.resultMessage = response.data.message;
                        return;
                    }
                    window.toggleSaveLoading(false, 'Enviar', 'frmNewsButton');
                    this.resultMessage = response.data.message;
                    this.loading = false;
                }).catch(() => {
                    window.toggleSaveLoading(false, 'Enviar', 'frmNewsButton');
                    this.resultMessage = 'Erro ao enviar! Por favor tente novamente!';
                    this.loading = false;
                });
            }
        },
        showTermo () {
            this.$http.get('/newsletter/texto').then((response) => {
                window.Swal.fire({
                    icon: 'warning',
                    title: 'Termo de assinatura de newsletter',
                    html: response.body,
                    showConfirmButton: false,
                    width: 800,
                    customClass: {
                        content: 'p-0'
                    }
                });
            });
        }
    }
};
</script>
